export const open = {
  methods: {
    open(data) {
      if (data) {
        this.$alert(data, this.$t("description"), {
          dangerouslyUseHTMLString: true,
          closeOnClickModal: true,
        }).catch(() => {
          return;
        });
      }
    },
  },
};
